import { ReportBase } from './base/report-base';

export class Report extends ReportBase { }